import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from '../constants';

export const isLoading = handleActions(
  {
    [combineActions(actionTypes.SEARCH_SUCCESS, actionTypes.SEARCH_FAILURE)]: () => false,
    [actionTypes.SEARCH_REQUEST]: () => true,
  },
  false,
);

export const results = handleActions(
  {
    [actionTypes.SEARCH_REQUEST]: () => ({}),
    [actionTypes.SEARCH_SUCCESS]: (state, action) => action.payload,
  },
  {},
);

export const shouldRefetch = handleActions(
  {
    [actionTypes.SHOULD_REFETCH]: (state, action) => action.payload,
  },
  false,
);


export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SEARCH_REQUEST,
      actionTypes.SEARCH_SUCCESS,
    )]: () => ({}),
    [actionTypes.SEARCH_FAILURE]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  isLoading,
  results,
  error,
  shouldRefetch,
});
